import concat from 'lodash/concat'
import memoize from 'lodash/memoize'
import find from 'lodash/find'
import set from 'lodash/set'
import * as scenes from '../scenes'
import * as overlayStyle from 'constants/overlayStyles'
// import * as customFieldTypes from 'constants/customFieldTypes'
// import * as sidebarSceneType from 'constants/sidebarSceneType'
// import * as stylePresetType from 'constants/stylePresetType'
import * as shopifyWizardActions from 'constants/shopifyWizardActions'
import * as shopifyAppSceneId from 'constants/shopifyAppSceneId'


export function hd (num) {
  return (
    [ // eslint-disable-line indent
      {
        id: shopifyAppSceneId.INTRO_ILLUSTRATION,
        shopifyBarTitle: 'Intro'
      },
      {
        id: shopifyAppSceneId.SET_TAGLINE,
        location: { scene: scenes.SPLASH, showcaseNum: 0 },
        overlays: [
          {
            overlayStyle: overlayStyle.BlueField,
            overlayKey: 'ou_splash__title',
            className: `ou_splash__title`,
            // canMove: true,
            // canResize: true
          }
        ],
        paths: [['splash', 'title']],
        action: shopifyWizardActions.EDIT_TEXT,
        shopifyBarTitle: 'Opening scene / Set your tagline',
        title: 'Set your tagline',
        description: 'Click Next to keep the tagline below.  Or enter a new tagline and click Next.',
        backTo: {
          sceneInc: -1
        },
        nextTo: {
          sceneInc: 1,
          title: 'Next'
        },
        width: '42em',
        height: '22em',
        top: '10em'
      },
      {
        id: shopifyAppSceneId.BULLET_POINTS,
        location: { scene: scenes.INTRO, showcaseNum: 0 },
        overlays: [
          {
            overlayStyle: overlayStyle.BlueField,
            overlayKey: 'ou_intro__content-line_1',
          },
          {
            overlayStyle: overlayStyle.BlueField,
            overlayKey: 'ou_intro__content-line_2',
          },
          {
            overlayStyle: overlayStyle.BlueField,
            overlayKey: 'ou_intro__content-line_3',
          }
        ],
        action: shopifyWizardActions.EDIT_TEXT,
        paths: [
          ['intro', 'line1'],
          ['intro', 'line2'],
          ['intro', 'line3']
        ],
        shopifyBarTitle: 'Set bullet points',
        title: 'Bullet points',
        description: 'Create 1-3 bullet points that highlight the best parts of your brand or product.',
        backTo: {
          sceneInc: -1
        },
        nextTo: {
          sceneInc: 3,
          title: 'Continue'
        },
        width: '42em',
        top: '6em',
        iaButton: {
          title: 'Change background',
          sceneInc: 1
        },
      },
      {
        id: shopifyAppSceneId.BULLET_POINTS_BACKGROUND,
        location: { scene: scenes.INTRO, showcaseNum: 0 },
        overlays: [],
        action: shopifyWizardActions.CHANGE_IMAGE,
        paths: [['intro', 'image']],
        shopifyBarTitle: 'Opening scene / Select opening image',
        title: 'Select your opening image',
        description: 'Make a lasting first impression with an attractive opening image for your store.',
        backTo: {
          sceneInc: -1
        },
        nextTo: {
          sceneInc: -1,
          title: 'Done'
        },
        iaButton: {
          title: 'Crop / Resize',
          sceneInc: 1
        },
        additional: {
          title: 'Crop / Resize',
          sceneInc: 1
        }
      },
      {
        id: shopifyAppSceneId.BULLET_POINTS_BACKGROUND_CROP,
        location: { scene: scenes.INTRO, showcaseNum: 0 },
        overlays: [],
        action: shopifyWizardActions.CROP,
        paths: [['intro', 'image']],
        shopifyBarTitle: 'Opening scene / Edit opening image',
        title: 'Crop / resize Image',
        description: 'Prevent stretching or image distortions on mobile.',
        backTo: {
          sceneInc: -1,
          title: 'Cancel'
        },
        nextTo: {
          sceneInc: -1,
          title: 'Looks good, continue'
        },
        previewEltId: 'ou_intro__cropper-image-preview'
      }
    ] // eslint-disable-line indent
  )
}


function createSlide (num, slidesCnt) {
  return [
    {
      id: shopifyAppSceneId.PRODUCTS_SCENES_DASHBOARD_NEW,
      location: { scene: scenes.SHOWCASE, showcaseNum: num, shareButtonsVisible: 0 },
      overlays: [],
      action: shopifyWizardActions.SCENES_DASHBOARD_NEW,
      slideIdPath: ['showcases', num, 'slideId'],
      title: 'Collections to display',
      shopifyBarTitle: 'Product scenes / Set collections',
      iaButton: {
        title: 'Design',
        sceneInc: 1
      },
      backTo: {
        sceneInc: -(num + 1) * 3,
        title: 'Back'
      },
      nextTo: {
        sceneInc: (slidesCnt - num) * 3,
        title: 'Continue'
      },
    },
    {
      id: shopifyAppSceneId.PRODUCT_SCENE_BACKGROUND,
      location: { scene: scenes.SHOWCASE, showcaseNum: num, shareButtonsVisible: 0 },
      slideIdPath: ['showcases', num, 'slideId'],
      overlays: [
        {
          overlayStyle: overlayStyle.BlueField,
          overlayKey: `ou_product_link_${num * 2 + 1}`,
          className: slideId => `ou_showcase_link_p${slideId}_0`,
          canMove: true
        },
        {
          overlayStyle: overlayStyle.BlueField,
          overlayKey: `ou_product_link_${num * 2 + 2}`,
          className: slideId => `ou_showcase_link_p${slideId}_1`,
          canMove: true
        }
      ],
      action: shopifyWizardActions.CHANGE_IMAGE,
      shopifyBarTitle: 'Collection scene design',
      title: 'Collection scene design',
      paths: [['showcases', num, 'image']],
      iaButton: {
        title: 'Crop / Resize',
        sceneInc: 1
      },
      backTo: {
        sceneInc: -1,
        title: 'Back'
      },
      nextTo: {
        sceneInc: -1,
        title: 'Continue'
      }
    },
    {
      id: shopifyAppSceneId.PRODUCT_SCENE_BACKGROUND_CROP,
      location: { scene: scenes.SHOWCASE, showcaseNum: num, shareButtonsVisible: 0 },
      overlays: [],
      action: shopifyWizardActions.CROP,
      paths: [['showcases', num, 'image']],
      shopifyBarTitle: 'Edit collection scene image',
      title: 'Crop / resize Image',
      description: 'Prevent stretching or image distortions on mobile.',
      backTo: {
        sceneInc: -1,
        title: 'Cancel'
      },
      nextTo: {
        sceneInc: -1,
        title: 'Looks good, continue'
      },
      previewEltId: `ou_showcase__image_preview${num}`
    }
  ]
}

export function tl (num) {
  return (
    [ // eslint-disable-line indent
      {
        id: shopifyAppSceneId.FINAL_SCENE_TEXT,
        location: { scene: scenes.SHOWCASE, showcaseNum: num, shareButtonsVisible: 0 },
        overlays: [
          {
            overlayStyle: overlayStyle.BlueField,
            overlayKey: 'ou_last-scene_title',
          },
          {
            overlayStyle: overlayStyle.BlueField,
            overlayKey: 'ou_last-scene_author',
          }
        ],
        paths: [
          ['lastScene', 'title'],
          ['lastScene', 'author']
        ],
        labels: [
          'Brand tagline',
          'Brand description'
        ],
        action: shopifyWizardActions.EDIT_TEXT,
        shopifyBarTitle: 'Add final Whimm text',
        title: 'Add text to your final Whimm image',
        description: 'Enter your tagline and brand description to greet shoppers as they enter your store.',
        iaButton: {
          title: 'Change background',
          sceneInc: 1
        },
        backTo: {
          sceneInc: -3
        },
        nextTo: {
          sceneInc: 3,
          title: 'Done'
        },
        width: '42em',
        height: '32em',
        top: '10em'
      },
      {
        id: shopifyAppSceneId.FINAL_SCENE_BACKGROUND,
        location: { scene: scenes.SHOWCASE, showcaseNum: num, shareButtonsVisible: 0 },
        overlays: [
          {
            overlayStyle: overlayStyle.BlueField,
            overlayKey: `ou_last-scene_image`,
          }
        ],
        action: shopifyWizardActions.CHANGE_IMAGE,
        shopifyBarTitle: 'Select final Whimm image',
        title: 'Select your final Whimm image',
        description: 'Welcome shoppers in style right before they enter your store',
        paths: [['lastScene', 'image']],
        iaButton: {
          title: 'Crop / Resize',
          sceneInc: 1
        },
        backTo: {
          sceneInc: -1,
          title: 'Back'
        },
        nextTo: {
          sceneInc: -1,
          title: 'Continue'
        },
        additional: {
          title: 'Crop / Resize',
          sceneInc: 1
        }
      },
      {
        id: shopifyAppSceneId.FINAL_SCENE_BACKGROUND_CROP,
        location: { scene: scenes.SHOWCASE, showcaseNum: num, shareButtonsVisible: 0 },
        overlays: [],
        action: shopifyWizardActions.CROP,
        paths: [['lastScene', 'image']],
        shopifyBarTitle: 'Edit final Whimm image',
        title: 'Crop / resize Image',
        description: 'Prevent stretching or image distortions on mobile.',
        backTo: {
          sceneInc: -1,
          title: 'Cancel'
        },
        nextTo: {
          sceneInc: -1,
          title: 'Looks good, continue'
        },
        previewEltId: 'ou_last-scene_image_preview'
      },
      {
        id: shopifyAppSceneId.FINAL_PREVIEW
      }
    ] // eslint-disable-line indent
  )
}


const emptyDashboard = {
  id: shopifyAppSceneId.PRODUCTS_SCENES_DASHBOARD_EMPTY,
  location: { scene: scenes.SHOWCASE, showcaseNum: 0, shareButtonsVisible: 0 },
  menu: [
    {
      action: shopifyWizardActions.SCENES_DASHBOARD,
      ui: {
        title: 'Product scenes',
        description: 'Create 1-8 product scenes.  Simply click on a scene and add 1-2 products to create.',
        backTo: {
          title: 'Back to intro scenes',
          sceneInc: -1,
        },
        nextTo: {
          title: 'Done adding product scenes'
        }
      }
    }
  ]
}

function abTestDiff (testGroup) {
  if (!testGroup) return []
  console.log('abTestDiff: testGroup', testGroup)
  const diffs = {
    'a': [],
    'b': [
      {
        id: shopifyAppSceneId.SET_TAGLINE,
        title: 'Set your tag',
        description: 'Click Next to keep the tagline below.  Or enter a new tagline and click Next.',
        nextTo: {
          sceneInc: 1,
          title: 'Next step'
        }
      },
      {
        id: shopifyAppSceneId.BULLET_POINTS,
        iaButton: null
      },

    ]
  }
  return diffs[testGroup]
}

function merge (original, diff) {
  for (const scene of diff) {
    const originalScene = find(original, s => s.id === scene.id)
    if (originalScene) {
      const {id, ...fields} = scene
      for (const field in fields) {
        set(originalScene, field, scene[field])
      }
    }
  }
  return original
}

export function createShopifyWizardConfSimple (slidesCnt, testGroup) {
  let res = hd(slidesCnt)
  for (let i = 0; i < slidesCnt; i++) {
    res = concat(res, createSlide(i, slidesCnt))
  }
  if (slidesCnt === 0) res.push(emptyDashboard)
  res = concat(res, tl(slidesCnt))
  res = merge(res, abTestDiff(testGroup))
  return res
}

export const createShopifyWizardConf = memoize(createShopifyWizardConfSimple)



// WEBPACK FOOTER //
// ./src/templates/outSide/template/shopifyWizardConf.js